import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { getCheckedIdsArr } from 'utils';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { uerAddOthersToContractChangeGql } from '../AgreementsQueries';

const TITLE_ADD_OTHER_ERROR = 'Отображение прочих затрат';

export const useAddOtherAgreements = (
    checkedIds: Record<string, boolean>,
    setCheckedIds: (value: Record<string, boolean>) => void,
    refreshAgreementsOther: () => void,
    setOpenModal: (value: boolean) => void,
    refreshFilters: () => void,
    agreementId: number,
) => {
    const dispatch = useDispatch();

    const [isSubmittedAddOther, setIsSubmittedAddOther] = useState<boolean>(false);

    const [addOtherAgreementsData, addOtherAgreementsStatus, addOtherAgreementsError, addOtherAgreementsRequest] =
        useRequest({
            requestId: 'addOthersToContractChang',
            query: uerAddOthersToContractChangeGql,
            withEffect: false,
        });

    useEffect(() => {
        if (
            addOtherAgreementsData &&
            addOtherAgreementsStatus === RequestStatus.SUCCESS &&
            addOtherAgreementsData?.uerAddOthersToContractChange?.result
        ) {
            refreshAgreementsOther();
            refreshFilters();
            setIsSubmittedAddOther(false);
            setOpenModal(false);
            setCheckedIds({});
        }
    }, [
        addOtherAgreementsData?.uerAddOthersToContractChange?.result,
        addOtherAgreementsStatus,
        addOtherAgreementsData,
        refreshAgreementsOther,
        refreshFilters,
        setCheckedIds,
        setOpenModal,
    ]);

    const handleAddOtherAgreements = useCallback(() => {
        const otherRowIds = getCheckedIdsArr(checkedIds);

        dispatch(
            addOtherAgreementsRequest({
                contractChangeId: agreementId,
                contractOtherCostIds: otherRowIds,
            }),
        );

        setIsSubmittedAddOther(true);
    }, [addOtherAgreementsRequest, agreementId, checkedIds, dispatch]);

    const handleCloseErrorModalAddRatio = useCallback(() => {
        setIsSubmittedAddOther(false);
    }, []);

    const handleCreateReportAddOther = () => {
        ExportCSVReport(addOtherAgreementsData?.uerAddOthersToContractChange?.validation);
    };

    return {
        titleAddError: TITLE_ADD_OTHER_ERROR,
        addOtherAgreementsData: addOtherAgreementsData?.uerAddOthersToContractChange,
        addOtherAgreementsStatus,
        addOtherAgreementsError,
        isSubmittedAddOther,
        handleAddOtherAgreements,
        handleCloseErrorModalAddRatio,
        handleCreateReportAddOther,
    };
};
